import { Accordion } from "react-bootstrap";
import "./accordion.css";
import PropTypes from "prop-types";

/**
 * Since accordion was used on react-bootstrap, we had to use AccordionComponent as a name.
 * General accordion component with default template.
 * React bootstrap accordion used
 * Style, class and children content can dynamically change
 */
const AccordionComponent = (props) => {
  const {
    accordionClass,
    style,
    accordionStyle,
    activeKey,
    onSelect,
    onDrop,
    onDragOver,
    onDragEnter,
    onDragLeave,
    defaultActiveKey,
    children
  } = props;

  let componentClass = "accordion-component";
  if (accordionClass) {
    componentClass += " " + accordionClass;
  }

  return (
    <div className={componentClass} style={style}>
      <Accordion
        className={accordionClass ? "accordion " + accordionClass : "accordion"}
        style={accordionStyle || null}
        activeKey={activeKey}
        onSelect={onSelect || null}
        onDrop={onDrop || null}
        onDragOver={onDragOver || null}
        onDragEnter={onDragEnter || null}
        onDragLeave={onDragLeave || null}
        defaultActiveKey={defaultActiveKey || null}
      >
        {children}
      </Accordion>
    </div>
  );
};

export default AccordionComponent;
